import { ErrorsUtil, MessageBoxComponent, WaitComponent } from '@sircon/sircon-ui-framework';
import { AccountHttpService } from 'src/providers/account-http.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UserHttpService } from 'src/providers/user-http.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-expired-password',
    templateUrl: './expired-password.component.html',
    styleUrls: ['./expired-password.component.less'],
    imports: [RouterLink, NgIf, WaitComponent, MessageBoxComponent]
})
export class ExpiredPasswordComponent implements OnInit {

    errors = ErrorsUtil.create();
    emailAddress;
    previousStateError;
    submitting;
    successful;
    loading = true;
    accountRecoveryAvailable = false;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private accountHttpService: AccountHttpService,
                private userHttpService: UserHttpService) {
    }

    ngOnInit() {
        this.emailAddress = this.route.snapshot.queryParams.emailAddress;
        this.previousStateError = this.route.snapshot.queryParams.previousStateError;
        this.userHttpService.getSecurityQuestionCodes(this.emailAddress)
            .subscribe(() => {
                this.accountRecoveryAvailable = true;
                this.loading = false;
            }, (response) => {
                if (response.status !== 404) {
                    this.handleErrorResponses(response);
                }
                this.loading = false;
            });
    }

    resendEmail() {
        if (!this.submitting) {
            ErrorsUtil.clear(this.errors);
            this.submitting = true;
            this.successful = false;

            this.accountHttpService.sendPasswordResetEmail({ emailAddress: this.emailAddress }).toPromise()
                .then(() => {
                    this.successful = true;
                })
                .catch((response) => this.handleErrorResponses(response))
                .finally(() => {
                    this.submitting = false;
                });
        }
    }

    handleErrorResponses(response) {
        this.errors = ErrorsUtil.mapResponse(response);
    }

    returnToLogin() {
        this.router.navigate(['/login'], { queryParams: {  reload: true  }});
    }
}
